import request from '@/utils/request'

// 员工列表
export const employee_list = (data) => {
    return request({
        url: '/erp/staff/index',
        method: 'get',
        data
    })
}


// 员工添加
export const employee_create = (data) => {
    return request({
        url: '/erp/staff/add',
        method: 'post',
        data
    })
}

// 员工状态员工删除
export const employee_update = (data) => {
    return request({
        url: '/erp/staff/edit-status',
        method: 'post',
        data
    })
}

// 员工姓名修改
export const employee_realname = (data) => {
    return request({
        url: '/erp/staff/edit-realname',
        method: 'post',
        data
    })
}

// 员工详情
export const employee_detail = (data) => {
    return request({
        url: '/erp/staff/detail',
        method: 'get',
        data
    })
}

// 员工角色信息
export const employee_role_info = (data) => {
        return request({
            url: '/erp/role/role-info',
            method: 'post',
            data
        })
    }
    // 员工角色修改
export const employee_role_edit = (data) => {
        return request({
            url: '/erp/role/set-uid-role',
            method: 'post',
            data
        })
    }
    // 店铺所有角色
export const employee_role_list = (data) => {
    return request({
        url: '/erp/role/get-use-manager',
        method: 'post',
        data
    })
}